export function noticeBanner() {
  const banner = document.querySelector(".farlo-ui-notice-banner");
  if (!banner) return;

  const list  = banner.querySelector(".farlo-ui-notice-banner__list");
  const items = Array.from(list.querySelectorAll(".farlo-ui-notice-banner__list-item"));
  const closeBtn = banner.querySelector(".farlo-ui-notice-banner__close");
  if (items.length === 0) return;

  const ACTIVE_ITEM = "farlo-ui-notice-banner__list-item--active";
  const ACTIVE_BANNER = "farlo-ui-notice-banner--active";
  const INTERVAL_MS = 10000;
  const TICKER_DELAY_MS = 1500;
  const MOBILE_QUERY = "(max-width: 980px)";
  const prefersReducedMotion =
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const mql = window.matchMedia ? window.matchMedia(MOBILE_QUERY) : null;
  const isMobile = () => (mql ? mql.matches : window.innerWidth <= 980);
  const isBannerActive = () => banner.classList.contains(ACTIVE_BANNER);

  const isPermanent = banner.dataset.permanent === "true";

  if (isPermanent || localStorage.getItem("farloNoticeBannerClosed") !== "1") {
    banner.classList.add(ACTIVE_BANNER);
  }

  let current = items.findIndex(el => el.classList.contains(ACTIVE_ITEM));
  if (current === -1) current = 0;
  items.forEach((el, i) => el.classList.toggle(ACTIVE_ITEM, i === current));

  function setListHeight() {
    const h = items[current].offsetHeight;
    list.style.maxHeight = h + "px";
    if (isBannerActive()) {
      document.documentElement.style.setProperty('--notice-banner-height', `${h}px`);
    } else {
      document.documentElement.style.setProperty('--notice-banner-height', `0px`);
    }
  }

  function initMobileTickerForItem(item) {
    if (!isMobile() || prefersReducedMotion || !isBannerActive()) return;

    let viewport = item.querySelector(".farlo-ui-notice-banner__content-viewport");
    let content  = item.querySelector(".farlo-ui-notice-banner__list-item__content");
    if (!content && viewport) content = viewport.querySelector(".farlo-ui-notice-banner__list-item__content");
    if (!content) return;

    if (!viewport) {
      viewport = document.createElement("div");
      viewport.className = "farlo-ui-notice-banner__content-viewport";
      content.replaceWith(viewport);
      viewport.appendChild(content);
    }

    const measureSingleLineWidth = (el) => {
      const cs = getComputedStyle(el);
      const clone = el.cloneNode(true);
      clone.style.whiteSpace   = "nowrap";
      clone.style.display      = "inline-block";
      clone.style.visibility   = "hidden";
      clone.style.position     = "absolute";
      clone.style.left         = "-10000px";
      clone.style.top          = "0";
      clone.style.font         = cs.font;
      clone.style.fontSize     = cs.fontSize;
      clone.style.fontWeight   = cs.fontWeight;
      clone.style.letterSpacing= cs.letterSpacing;
      clone.style.wordSpacing  = cs.wordSpacing;
      clone.style.textTransform= cs.textTransform;

      viewport.appendChild(clone);
      const w = Math.ceil(clone.scrollWidth);
      clone.remove();
      return w;
    };

    let viewportWidth = Math.ceil(viewport.clientWidth) || Math.ceil(list.clientWidth);
    const contentWidth = measureSingleLineWidth(content);
    const needsMarquee = contentWidth > viewportWidth + 1;

    let track = viewport.querySelector(".farlo-ui-notice-banner__ticker");

    if (needsMarquee) {
      if (!track) {
        track = document.createElement("div");
        track.className = "farlo-ui-notice-banner__ticker farlo-ui-notice-banner__ticker--paused";
        const c1 = content.cloneNode(true);
        const c2 = content.cloneNode(true);
        c1.style.marginRight = "2rem";
        track.appendChild(c1);
        track.appendChild(c2);
        content.replaceWith(track);
      }
      const GAP = 32;
      const distance = contentWidth + GAP;
      const SPEED = 60;
      const duration = Math.max(10, Math.round(distance / SPEED));
      track.style.setProperty("--farlo-marquee-width", distance + "px");
      track.style.setProperty("--farlo-marquee-duration", duration + "s");
    } else if (track) {
      const firstSpan = track.querySelector(".farlo-ui-notice-banner__list-item__content");
      if (firstSpan) track.replaceWith(firstSpan);
    }
  }

  function initAllTickers() {
    items.forEach(initMobileTickerForItem);
  }

  function teardownTickerForItem(item) {
    const viewport = item.querySelector(".farlo-ui-notice-banner__content-viewport");
    if (!viewport) return;

    const track = viewport.querySelector(".farlo-ui-notice-banner__ticker");
    if (track) {
      const firstSpan = track.querySelector(".farlo-ui-notice-banner__list-item__content");
      if (firstSpan) track.replaceWith(firstSpan);
    }

    const content = viewport.querySelector(".farlo-ui-notice-banner__list-item__content");
    if (content) viewport.replaceWith(content);
  }

  function teardownAllTickers() {
    banner.querySelectorAll(".farlo-ui-notice-banner__ticker")
      .forEach(el => el.classList.add("farlo-ui-notice-banner__ticker--paused"));
    items.forEach(teardownTickerForItem);
  }

  function pauseAllTickers() {
    banner.querySelectorAll(".farlo-ui-notice-banner__ticker")
      .forEach(el => el.classList.add("farlo-ui-notice-banner__ticker--paused"));
  }

  function unpauseActiveTicker() {
    const track = items[current].querySelector(".farlo-ui-notice-banner__ticker");
    if (track) track.classList.remove("farlo-ui-notice-banner__ticker--paused");
  }

  let tickerDelayTimeout = null;
  function delayActiveTicker() {
    if (!isBannerActive()) return;
    if (tickerDelayTimeout) clearTimeout(tickerDelayTimeout);
    pauseAllTickers();
    tickerDelayTimeout = setTimeout(() => {
      if (prefersReducedMotion) return;
      if (!isMobile()) return;
      if (banner.matches(":hover")) return;
      unpauseActiveTicker();
    }, TICKER_DELAY_MS);
  }

  function next() {
    items[current].classList.remove(ACTIVE_ITEM);
    current = (current + 1) % items.length;
    items[current].classList.add(ACTIVE_ITEM);

    if (isMobile()) initMobileTickerForItem(items[current]);
    delayActiveTicker();
    requestAnimationFrame(setListHeight);
  }

  let timer = null;
  function start() {
    if (!isBannerActive() || prefersReducedMotion) return;
    if (!timer && items.length > 1) timer = setInterval(next, INTERVAL_MS);
    delayActiveTicker();
  }
  function stop() {
    if (timer) { clearInterval(timer); timer = null; }
    if (tickerDelayTimeout) { clearTimeout(tickerDelayTimeout); tickerDelayTimeout = null; }
    pauseAllTickers();
  }

  banner.addEventListener("mouseenter", stop);
  banner.addEventListener("mouseleave", start);

  if (closeBtn && !isPermanent) {
    closeBtn.addEventListener("click", () => {
      stop();
      banner.classList.remove(ACTIVE_BANNER);
      localStorage.setItem("farloNoticeBannerClosed", "1");
      setListHeight();
    });
    // If closed previously, ensure it's not active
    if (localStorage.getItem("farloNoticeBannerClosed") === "1") {
      banner.classList.remove(ACTIVE_BANNER);
    }
  }

  function applyBreakpointBehavior() {
    if (!isBannerActive()) {
      teardownAllTickers();
      pauseAllTickers();
      setListHeight();
      return;
    }
    if (isMobile()) {
      initAllTickers();
      delayActiveTicker();
    } else {
      teardownAllTickers();
      pauseAllTickers();
    }
    setListHeight();
  }

  if (mql) {
    if (mql.addEventListener) {
      mql.addEventListener("change", applyBreakpointBehavior);
    } else if (mql.addListener) {
      mql.addListener(applyBreakpointBehavior);
    }
  }

  window.addEventListener("resize", applyBreakpointBehavior, { passive: true });

  applyBreakpointBehavior();
  requestAnimationFrame(() => {
    if (isMobile() && isBannerActive()) initMobileTickerForItem(items[current]);
    setListHeight();
    delayActiveTicker();
  });
  window.addEventListener("load", () => {
    applyBreakpointBehavior();
    delayActiveTicker();
  }, { once: true });

  start();
}
